import { render } from "./CopyPasteCode.vue?vue&type=template&id=4ac481c9"
import script from "./CopyPasteCode.vue?vue&type=script&lang=js"
export * from "./CopyPasteCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__